<template>
    <div>
        <h1 class="display-heading d-flex justify-content-between">
            <div>{{ patientName }} Past Prescriptions</div>
            <button class="btn btn-danger" @click="closeWindow">Close</button>
        </h1>

        <div ref="tableSection">
            <div v-show="prescriptions.length === 0" class="text-center font-italic">
                {{isTableLoading ? "Loading Data": "No Data"}}
            </div>
            <div v-for="(prescription, index) in prescriptions" :key="index">
                <div class="card mb-5">
                    <div class="card-header d-flex justify-content-between align-items-baseline">
                        <span>Prescription Date : {{ convertToUserReadableDate(prescription.prescribedDate) }}</span>
                    </div>
                    <div class="card-body">
                        <prescription-detail :isEdit="false" v-model="prescription.items"
                            :pharmacyId="pharmacyId" :drugType="2">
                            <template v-if="prescription.items.length> 0">
                                    <form data-vv-scope="prescription-valid-days">
                                        <div id="prescription" class="d-flex align-items-baseline">
                                            <label class="mr-2 mb-0">{{ "Prescription valid until"}}  </label>
                                            <div>
                                                {{prescription.prescriptionValidUntil ? convertToUserReadableDate(prescription.prescriptionValidUntil): '-'}}
                                            </div>
                                        </div>
                                    </form>
                            </template>
                        </prescription-detail>
                    </div>
                </div>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import {
    convertToUserReadableDate,
    constructPrescriptionList
} from '@/utilities';
import pagination from '@/components/pagination';
import prescriptionDetail from '@/components/prescription';
export default {
    'components': {
        prescriptionDetail,
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getDoctors();
            });
        }
    },
    data () {
        return {
            // 'columnsCount': 1,
            convertToUserReadableDate,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'prescriptions': [],
            'patientId': null,
            'patientName': null,
            'pharmacyId': 'c790b8e8-a595-11ea-a7bf-00163e000d23'
        };
    },
    mounted () {
        // this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        this.patientId = this.$route.params.patientId;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getPrescriptions();
        this.getPatientDetails();
    },
    'methods': {
        getPatientDetails () {
            this.axios.get('user/GetUserDetails', {
                'params': {
                    'userId': this.patientId
                }
            }).then(({
                data
            }) => {
                if (data.data) {
                    let profileData = data.data;
                    this.patientName = profileData.f;
                }
            });
        },
        getPrescriptions () {
            this.axios.post('Clinic/GetPatientPastPrescriptions', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'pi': this.patientId
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.prescriptions = list.map((prescription) => ({
                    'prescribedDate': prescription.cd,
                    'prescriptionValidUntil': prescription.vu,
                    'items': constructPrescriptionList(prescription.pil)
                }));
            });
        },
        closeWindow () {
            window.close();
        }
    }
};

</script>

<style>

</style>
